import { render, staticRenderFns } from "./PayrollDetailListing.vue?vue&type=template&id=6e998f06"
import script from "./PayrollDetailListing.vue?vue&type=script&lang=js"
export * from "./PayrollDetailListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports